import classNames from 'classnames';
import React from 'react';
import Button from './Button';
import * as styles from './IconButton.module.scss';

export const NEGATIVE_SPACE = parseInt(styles.negativeSpace, 10);

type IconButtonProps = React.ComponentPropsWithoutRef<typeof Button> & {
  applyNegativeMargin?: boolean;
  children: string | React.ReactNode;
  'aria-label': string;
};

const IconButton = React.forwardRef<HTMLButtonElement, IconButtonProps>(
  (
    {
      active,
      applyNegativeMargin = false,
      children,
      className,
      ...props
    }: IconButtonProps,
    ref,
  ) => (
    <Button
      {...props}
      ref={ref}
      active={active}
      className={classNames(styles.iconButton, className, {
        [styles.active]: active,
        [styles.negativeMargin]: applyNegativeMargin,
      })}
      icon={children}
    />
  ),
);

export default IconButton;
